import { CartLinesUpdateEvent } from '@shopify/events';

document.addEventListener('click', async (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-hs-addon]') : null;
  if (!button || button.disabled) return;
  button.disabled = true;

  const id = button.dataset.hsAddon;
  const sections = [...document.querySelectorAll('cart-items-component')]
    .map((item) => item.dataset.sectionId)
    .filter(Boolean);
  const deferred = CartLinesUpdateEvent.createPromise();
  button.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'cart',
      lines: [{ merchandiseId: id, quantity: 1 }],
      promise: deferred.promise,
    })
  );

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id, quantity: 1, sections: sections.join(','), sections_url: location.pathname }),
    });
    const added = await response.json();
    if (!response.ok) throw new Error(added.description || 'Could not add this item');
    const cart = await (await fetch('/cart.js')).json();
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: 'hs-addon',
        sourceId: String(id),
        itemCount: 1,
        productId: String(added.product_id),
        sections: added.sections,
        didError: false,
      },
    });
  } catch (error) {
    deferred.reject(error);
    location.assign('/cart');
  }
});
